import * as React from 'react';

// Visitor Hub mark — a lanyard clip above a pass card carrying a person silhouette ("Concept 1c,
// Visitor pass"). Ink tile (#050503) baked in, matching the LogoAccessIcon/LogoLockerApp
// convention. Visitor Hub has not been assigned a palette slot (unlike Rooms/orange,
// Access/teal, Lockers/green, Vision/violet) — stays black-and-white; do not tint it.
//
// The inner detail (head, shoulders, clip notch) is painted in the tile's background colour on
// top of the mark rather than cut out, so this asset is NOT transparent through that detail — it
// is built for the #050503 tile behind it. Never render it over a photo, gradient, or another
// product's colour.
const LogoVisitorHubIcon = (props) => (
	<svg xmlns='http://www.w3.org/2000/svg' width={120} height={120} viewBox='0 0 120 120' fill='none' {...props}>
		<rect x={0.5} y={0.5} width={119} height={119} rx={28} fill='#050503' />
		<svg x={22} y={22} width={76} height={76} viewBox='0 0 96 96'>
			<rect x={41} y={8} width={14} height={14} rx={5} fill='#fff' />
			<rect x={18} y={20} width={60} height={68} rx={8} fill='#fff' />
			<rect x={41} y={14} width={14} height={10} fill='#050503' />
			<circle cx={48} cy={46} r={10} fill='#050503' />
			<path d='M33,76 A15,15 0 0 1 63,76 Z' fill='#050503' />
		</svg>
	</svg>
);

export default LogoVisitorHubIcon;
